// Vendor imports
const PropTypes = require('prop-types')
const { connect } = require('react-redux')

function RenderRollout({ isIncluded, renderIncluded, renderExcluded }) {
  if (isIncluded) {
    return renderIncluded()
  }
  return renderExcluded ? renderExcluded() : null
}

RenderRollout.propTypes = {
  rolloutKey: PropTypes.string.isRequired,
  isIncluded: PropTypes.bool,
  // Render props
  renderExcluded: PropTypes.func,
  renderIncluded: PropTypes.func.isRequired
}

function RenderExperiment({ modifier, renderByModifier, renderWithModifier }) {
  // Prefer modifier-specific render functions (when specified)
  if (renderByModifier) {
    if (modifier && renderByModifier[modifier]) {
      return renderByModifier[modifier]()
    }
    // Fall-back to the "control" modifier if no other render function applies
    if (renderByModifier.control) {
      return renderByModifier.control()
    }
  }
  if (renderWithModifier) {
    return renderWithModifier(modifier)
  }
  return null
}

RenderExperiment.propTypes = {
  experimentKey: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  // Render props
  renderByModifier: PropTypes.objectOf(PropTypes.func),
  renderWithModifier: PropTypes.func
}

const CheckRollout = connect(mapRolloutStateToProps)(RenderRollout)
const CheckExperiment = connect(mapExperimentStateToProps)(RenderExperiment)

module.exports = {
  CheckRollout,
  CheckExperiment
}

function mapRolloutStateToProps(state, ownProps) {
  return {
    isIncluded: state.user.hasRollout(ownProps.rolloutKey)
  }
}

function mapExperimentStateToProps(state, ownProps) {
  return {
    modifier: state.user.getExperiment(ownProps.experimentKey)
  }
}
